import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PrButtonComponent } from '@app/components/pr-button/pr-button/pr-button.component';
import * as _ from 'lodash';

@Component({
    selector: 'pr-table-form-add',
    templateUrl: './pr-table-form-add.component.html',
    styleUrls: ['./pr-table-form-add.component.scss'],
    standalone: false
})
export class PrTableFormAddComponent extends PrButtonComponent {
  @Input() options;
  @Input() buttonLabel;
  @Input() buttonIcon: string = 'add';
  @Output() optionSelected = new EventEmitter();
  opened: boolean = false;
  searchValue: any = '';

  @ViewChild('searchInput') searchInput: ElementRef;

  constructor() {
    super();
  }

  focusSearchInput() {
    this.searchInput.nativeElement.focus();
  }

  get formatedOptions() {
    const filteredOptions = this.searchValue
      ? _.filter(this.options, o =>
          o.name.toLowerCase().includes(this.searchValue.toLowerCase()),
        )
      : this.options;
    if (!filteredOptions.length) {
      return [{ name: 'Aucun résultat trouvé' }];
    }
    return filteredOptions;
  }
}
